export default __webpack_public_path__ + "static/marvin-laird-6ed2e0a38ffb1fd1efe2e3306a6ca9ad.jpg";